import { render } from "./LegalModal.vue?vue&type=template&id=bd9b4efc&scoped=true"
import script from "./LegalModal.vue?vue&type=script&lang=js"
export * from "./LegalModal.vue?vue&type=script&lang=js"

import "./LegalModal.vue?vue&type=style&index=0&id=bd9b4efc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd9b4efc"]])

export default __exports__